const BLOG_DATA = [
  {
    id: 1,
    title: 'Cooking Dining Experience',
    href: '/',
    imgSrc: '/assets/unsplash_ThLVnKdeH1k2.png',
    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin'
  },
  {
    id: 2,
    title: 'Cooking Dining Experience',
    href: '/public/assets/unsplash_ThLVnKdeH1k2.png',
    imgSrc: '/assets/hcmp33562_145940222.png',
    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin'
  },
  {
    id: 3,
    title: 'Cooking Dining Experience',
    href: '/',
    imgSrc: '/assets/DirtCandy-0242.png',
    body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin'
  }
];

export default BLOG_DATA; 